class ProductCard extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.data = {}
    this.renderPromise = null
  }

  async connectedCallback () {
    const propData = this.getAttribute('data-prop-data')

    if (propData) {
      this.data = JSON.parse(propData)

      this.renderPromise = this.renderPromise || this.renderInitial()
    }
  }

  getRenderPromise () {
    if (this.renderPromise) {
      return this.renderPromise
    }

    const propData = this.getAttribute('data-prop-data')

    if (!propData) {
      return Promise.resolve()
    }

    if (!this.data?.url) {
      this.data = JSON.parse(propData)
    }

    this.renderPromise = this.renderInitial()

    return this.renderPromise
  }

  async renderInitial () {
    const productHandle = this.handle
    const productPath = this.data.collectionHandle
      ? `/collections/${this.data.collectionHandle}/products/${productHandle}`
      : `/products/${productHandle}`

    try {
      const response = await fetch(`${productPath}?section_id=product-card`)
      if (!response.ok) throw new Error('Failed to fetch product card section')
      const text = await response.text()
      const html = new DOMParser().parseFromString(text, 'text/html')

      const productCardContent = html.querySelector(
        `#shopify-section-product-card`,
      )
      if (productCardContent?.children.length) {
        this.innerHTML = productCardContent.innerHTML
        this.applyCnstrcAttributes()
        return
      }

      this.removePlaceholderCard()
    } catch (error) {
      console.error('Failed to fetch product card section:', error)
      this.removePlaceholderCard()
    }
  }

  removePlaceholderCard () {
    this.closest('li')?.remove()
  }

  applyCnstrcAttributes () {
    const productArticle = this.querySelector('.prd-Card')

    if (!productArticle) {
      return
    }

    if (this.data.podId) {
      productArticle.removeAttribute('role')
      productArticle.removeAttribute('aria-label')
    }

    if (this.data.podId) {
      productArticle.setAttribute('data-cnstrc-item', 'recommendation')

      if (this.data.strategyId) {
        productArticle.setAttribute(
          'data-cnstrc-strategy-id',
          this.data.strategyId,
        )
      } else {
        productArticle.removeAttribute('data-cnstrc-strategy-id')
      }
    }

    this.setCnstrcAttribute(
      productArticle,
      'data-cnstrc-item-id',
      this.data.productId,
    )
    this.setCnstrcAttribute(
      productArticle,
      'data-cnstrc-item-name',
      this.data.itemName,
    )
    this.setCnstrcAttribute(
      productArticle,
      'data-cnstrc-item-variation-id',
      this.data.variationId,
    )
    this.setCnstrcAttribute(
      productArticle,
      'data-cnstrc-item-price',
      this.data.itemPrice,
    )
  }

  setCnstrcAttribute (element, name, value) {
    const nextValue = value || element.getAttribute(name)

    if (!nextValue) {
      element.removeAttribute(name)
      return
    }

    element.setAttribute(name, nextValue)
  }

  get handle () {
    return this.data.url.split('products/').pop()
  }
}

customElements.define('product-card', ProductCard)
